import { errorDuck } from './error';
import { accountDuck } from './account';
import { locationDuck } from './location';
import { newsletterDuck } from './newsletter';
import { searchDuck } from './search';
import { waitlistDuck } from './waitlist';
import { wishlistDuck } from './wishlist';
import { headerDuck } from './header';
import { articleDuck } from './article';
import { menuDuck } from './menu';
import { cartDuck } from './cart';
import { retailDuck } from './retail';
import { mobileHeaderDuck } from './mobileHeader';
import { offlineDuck } from './offline';
import { mobilepayDuck } from './mobilepay';
import { loyaltyDuck } from './loyalty';
import { rewardsDuck } from './rewards';
var ducks = {
  error: errorDuck,
  account: accountDuck,
  location: locationDuck,
  newsletter: newsletterDuck,
  search: searchDuck,
  waitlist: waitlistDuck,
  header: headerDuck,
  article: articleDuck,
  menu: menuDuck,
  cart: cartDuck,
  wishlist: wishlistDuck,
  retail: retailDuck,
  mobileHeader: mobileHeaderDuck,
  offline: offlineDuck,
  mobilepay: mobilepayDuck,
  loyalty: loyaltyDuck,
  rewards: rewardsDuck
};
export default ducks;